(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["wzlt-buy-now-button"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('wzlt-buy-now-button')) {
    class WzltBuyNowButton extends HTMLElement {
      connectedCallback() {
        if (this._initialized) return;
        this._initialized = true;

        this.form = this.querySelector('form');
        this.variantInput = this.querySelector('[data-variant-input]');
        this.quantityInput = this.querySelector('[data-quantity-input]');
        this.submitButton = this.querySelector('[data-buy-now-submit]');
        this.textEl = this.querySelector('[data-buy-now-text]');
        this.checkoutUrl = this.dataset.checkoutUrl || '/checkout';
        this.cartAddJsUrl = this.dataset.cartAddJsUrl || '/cart/add.js';
        this.cartClearUrl = this.dataset.cartClearUrl || '/cart/clear.js';
        this.clearCart = this.dataset.clearCart === 'true';
        this.soldOutLabel = this.dataset.soldOutLabel || 'Lorem ipsum';
        this.loadingLabel = this.dataset.loadingLabel || 'Lorem ipsum';
        this.defaultLabel = this.textEl ? this.textEl.textContent.trim() : '';
        this.sectionId = this.dataset.sectionId;
        this.productId = this.dataset.productId || '';
        this._variantsById = this._parseVariants(this.dataset.variants);

        if (!this.form || !this.variantInput || !this.submitButton) return;

        if (this.sectionId) {
          this._section = document.getElementById('shopify-section-' + this.sectionId);
        }

        this._onVariantEvent = this._onVariantEvent.bind(this);
        this._onShopifyProductSelect = this._onShopifyProductSelect.bind(this);
        this._onDocumentChange = this._onDocumentChange.bind(this);
        this._onPickerPointer = this._onPickerPointer.bind(this);
        this._onSubmit = this._onSubmit.bind(this);
        this._onQuantityChange = this._onQuantityChange.bind(this);
        this._stopPropagation = this._stopPropagation.bind(this);
        this._onPopState = this._onPopState.bind(this);

        document.addEventListener('variant:change', this._onVariantEvent);
        document.addEventListener('variant:changed', this._onVariantEvent);
        document.addEventListener('variant:update', this._onVariantEvent);
        document.addEventListener('variant:selected', this._onVariantEvent);
        document.addEventListener('product:select', this._onVariantEvent);
        document.addEventListener('shopify:product:select', this._onShopifyProductSelect);
        document.addEventListener('change', this._onDocumentChange, true);
        document.addEventListener('click', this._onPickerPointer, true);
        window.addEventListener('popstate', this._onPopState);

        this.form.addEventListener('submit', this._onSubmit, true);
        this.submitButton.addEventListener('click', this._stopPropagation, true);
        this._bindMainProductForm();
        this._syncFromPage();
      }

      disconnectedCallback() {
        document.removeEventListener('variant:change', this._onVariantEvent);
        document.removeEventListener('variant:changed', this._onVariantEvent);
        document.removeEventListener('variant:update', this._onVariantEvent);
        document.removeEventListener('variant:selected', this._onVariantEvent);
        document.removeEventListener('product:select', this._onVariantEvent);
        document.removeEventListener('shopify:product:select', this._onShopifyProductSelect);
        document.removeEventListener('change', this._onDocumentChange, true);
        document.removeEventListener('click', this._onPickerPointer, true);
        window.removeEventListener('popstate', this._onPopState);
        this._unbindMainProductForm();
        if (this._variantObserver) {
          this._variantObserver.disconnect();
          this._variantObserver = null;
        }
      }

      _stopPropagation(event) {
        event.stopPropagation();
      }

      _parseVariants(raw) {
        var map = {};
        if (!raw) return map;
        try {
          var list = JSON.parse(raw);
          if (!Array.isArray(list)) return map;
          for (var i = 0; i < list.length; i++) {
            var item = list[i];
            if (!item || item.id == null) continue;
            map[String(item.id)] = item;
          }
        } catch (err) {}
        return map;
      }

      _normalizeVariantId(value) {
        if (value == null || value === '') return '';
        var text = String(value);
        var match = text.match(/(\d+)\s*$/);
        return match ? match[1] : text;
      }

      _variantIdFromNode(node) {
        if (!node) return '';
        if (node.getAttribute) {
          var dataId = node.getAttribute('data-variant-id');
          if (dataId) return this._normalizeVariantId(dataId);
        }
        if (node.dataset && node.dataset.variantId) {
          return this._normalizeVariantId(node.dataset.variantId);
        }
        if (node.options && node.selectedIndex >= 0) {
          var option = node.options[node.selectedIndex];
          if (option && option.getAttribute) {
            var optionId = option.getAttribute('data-variant-id');
            if (optionId) return this._normalizeVariantId(optionId);
          }
        }
        if (node.name === 'id' && node.value) return this._normalizeVariantId(node.value);
        return '';
      }

      _isMainProductScope(el) {
        if (!el || !el.closest) return false;
        if (el.closest('product-card') || el.closest('quick-add-dialog') || el.closest('quick-add-modal')) {
          return false;
        }
        return true;
      }

      _readVariantIdFromPage() {
        var pickers = document.querySelectorAll('variant-picker');
        for (var i = 0; i < pickers.length; i++) {
          var picker = pickers[i];
          if (!this._isMainProductScope(picker)) continue;
          var checked = picker.querySelector('input[data-variant-id]:checked, input[type="radio"]:checked');
          if (checked) {
            var checkedId = this._variantIdFromNode(checked);
            if (checkedId) return checkedId;
          }
          var selectedOption = picker.querySelector(
            'select option[selected][data-variant-id], select option:checked[data-variant-id]'
          );
          if (selectedOption) {
            var selectedId = this._variantIdFromNode(selectedOption);
            if (selectedId) return selectedId;
          }
        }

        var fallbackChecked = document.querySelector(
          '.product-information input[data-variant-id]:checked, .product-details input[data-variant-id]:checked, input[data-variant-id]:checked'
        );
        if (fallbackChecked && this._isMainProductScope(fallbackChecked)) {
          var fallbackId = this._variantIdFromNode(fallbackChecked);
          if (fallbackId) return fallbackId;
        }

        var scope = this._section || document;
        var inputs = scope.querySelectorAll(
          'form.shopify-product-form input[name="id"], product-form-component input[name="id"], product-form input[name="id"], [data-product-form] input[name="id"], form[action*="/cart/add"] input[name="id"]'
        );
        for (var j = 0; j < inputs.length; j++) {
          var input = inputs[j];
          if (input === this.variantInput) continue;
          if (!this._isMainProductScope(input)) continue;
          if (input.value) return this._normalizeVariantId(input.value);
        }

        var params = new URLSearchParams(window.location.search);
        if (params.get('variant')) return this._normalizeVariantId(params.get('variant'));

        return this.variantInput ? this._normalizeVariantId(this.variantInput.value) : '';
      }

      _readQuantityFromPage() {
        var scope = this._section || document;
        var qty = scope.querySelector(
          'quantity-selector-component input[name="quantity"], quantity-input input[name="quantity"], form.shopify-product-form input[name="quantity"], product-form-component input[name="quantity"], [data-product-form] input[name="quantity"]'
        );
        if (qty && qty.value) {
          var n = parseInt(qty.value, 10);
          if (n > 0) return String(n);
        }
        return this.quantityInput ? this.quantityInput.value : '1';
      }

      _idFromEvent(event) {
        if (!event) return '';
        var fromTarget = this._variantIdFromNode(event.target);
        if (fromTarget) return fromTarget;

        var detail = event.detail || {};
        if (detail.variantId) return this._normalizeVariantId(detail.variantId);
        if (detail.detail && detail.detail.variantId) {
          return this._normalizeVariantId(detail.detail.variantId);
        }
        var variant = detail.variant || (detail.data && detail.data.variant);
        if (variant && variant.id != null) return this._normalizeVariantId(variant.id);
        var resource = detail.resource || (detail.data && detail.data.resource);
        if (resource && resource.id != null) return this._normalizeVariantId(resource.id);
        return '';
      }

      _bindMainProductForm() {
        var scope = this._section || document;
        var mainForm =
          scope.querySelector('product-form-component form') ||
          scope.querySelector('form.shopify-product-form') ||
          scope.querySelector('product-form form') ||
          scope.querySelector('[data-product-form] form') ||
          document.querySelector('product-form-component form') ||
          document.querySelector('form.shopify-product-form');

        if (!mainForm || mainForm === this.form) return;

        this._mainForm = mainForm;
        this._mainVariantInput = mainForm.querySelector('input[name="id"], select[name="id"]');
        this._mainQuantityInput = mainForm.querySelector('input[name="quantity"]');

        if (this._mainVariantInput) {
          this._mainVariantInput.addEventListener('change', this._onVariantEvent);
          this._mainVariantInput.addEventListener('input', this._onVariantEvent);
          if (typeof MutationObserver === 'function') {
            var self = this;
            this._lastSeenVariantId = this._normalizeVariantId(this._mainVariantInput.value);
            this._variantObserver = new MutationObserver(function () {
              self._syncFromPage();
            });
            this._variantObserver.observe(this._mainVariantInput, {
              attributes: true,
              attributeFilter: ['value', 'disabled']
            });
            if (this._mainForm) {
              this._variantObserver.observe(this._mainForm, {
                childList: true,
                subtree: true,
                attributes: true,
                attributeFilter: ['value', 'checked', 'aria-checked', 'selected']
              });
            }
          }
        }

        if (this._mainQuantityInput) {
          this._mainQuantityInput.addEventListener('change', this._onQuantityChange);
          this._mainQuantityInput.addEventListener('input', this._onQuantityChange);
        }
      }

      _unbindMainProductForm() {
        if (this._mainVariantInput) {
          this._mainVariantInput.removeEventListener('change', this._onVariantEvent);
          this._mainVariantInput.removeEventListener('input', this._onVariantEvent);
        }
        if (this._mainQuantityInput) {
          this._mainQuantityInput.removeEventListener('change', this._onQuantityChange);
          this._mainQuantityInput.removeEventListener('input', this._onQuantityChange);
        }
      }

      _onPickerPointer(event) {
        var target = event.target;
        if (!target || !target.closest) return;
        if (!target.closest('variant-picker') && !target.closest('.variant-picker') && !target.closest('[data-option-value-id]')) {
          return;
        }
        if (!this._isMainProductScope(target)) return;
        var self = this;
        requestAnimationFrame(function () {
          self._syncFromPage();
          setTimeout(function () {
            self._syncFromPage();
          }, 50);
        });
      }

      _syncFromPage() {
        var variantId = this._readVariantIdFromPage();
        if (variantId) this._setVariant(variantId, null);
        if (this.quantityInput) this.quantityInput.value = this._readQuantityFromPage();
      }

      _onPopState() {
        this._syncFromPage();
      }

      _onDocumentChange(event) {
        var target = event.target;
        if (!target) return;

        var fromNode = this._variantIdFromNode(target);
        if (fromNode) {
          this._setVariant(fromNode, null);
          return;
        }

        if (target.name === 'quantity') {
          this._onQuantityChange(event);
          return;
        }

        if (target.closest && target.closest('variant-picker') && this._isMainProductScope(target)) {
          this._syncFromPage();
        }
      }

      _onQuantityChange(event) {
        if (!this.quantityInput) return;
        var quantity = parseInt(event.target.value, 10);
        this.quantityInput.value = quantity > 0 ? String(quantity) : '1';
      }

      _onVariantEvent(event) {
        var id = this._idFromEvent(event) || this._readVariantIdFromPage();
        if (!id) return;
        var available = null;
        var detail = event && event.detail ? event.detail : {};
        var variant = detail.variant || (detail.data && detail.data.variant);
        if (variant && typeof variant.available === 'boolean') available = variant.available;
        else if (variant && typeof variant.availableForSale === 'boolean') {
          available = variant.availableForSale;
        }
        this._setVariant(id, available);
      }

      _onShopifyProductSelect(event) {
        var self = this;
        var apply = function (result) {
          var variant = result && result.variant ? result.variant : result;
          if (!variant || variant.id == null) {
            self._syncFromPage();
            return;
          }
          var available =
            typeof variant.availableForSale === 'boolean'
              ? variant.availableForSale
              : typeof variant.available === 'boolean'
                ? variant.available
                : null;
          self._setVariant(self._normalizeVariantId(variant.id), available);
        };

        if (event && event.promise && typeof event.promise.then === 'function') {
          event.promise.then(apply).catch(function () {
            self._syncFromPage();
          });
          return;
        }

        this._onVariantEvent(event);
      }

      _setVariant(variantId, isAvailable) {
        var id = this._normalizeVariantId(variantId);
        if (!id || !this.variantInput) return;

        this.variantInput.value = id;
        this.variantInput.disabled = false;

        var available = isAvailable;
        if (typeof available !== 'boolean' && this._variantsById[id]) {
          available = !!this._variantsById[id].available;
        }
        if (typeof available === 'boolean') {
          this._setAvailability(available);
        }
      }

      _setAvailability(isAvailable) {
        if (!this.submitButton || !this.textEl) return;

        this.submitButton.disabled = !isAvailable;
        this.submitButton.setAttribute('aria-disabled', isAvailable ? 'false' : 'true');
        this.textEl.textContent = isAvailable ? this.defaultLabel : this.soldOutLabel;
      }

      _setLoading(isLoading) {
        if (!this.submitButton || !this.textEl) return;
        this.submitButton.disabled = isLoading;
        this.submitButton.setAttribute('aria-busy', isLoading ? 'true' : 'false');
        this.textEl.textContent = isLoading ? this.loadingLabel : this.defaultLabel;
      }

      _goToCheckout() {
        window.location.href = this.checkoutUrl;
      }

      async _onSubmit(event) {
        event.preventDefault();
        event.stopPropagation();

        this._syncFromPage();

        var variantId = this._normalizeVariantId(this.variantInput.value);
        var quantity = parseInt(this.quantityInput.value, 10) || 1;

        if (!variantId) return;

        var variantMeta = this._variantsById[variantId];
        if (variantMeta && variantMeta.available === false) {
          this._setAvailability(false);
          return;
        }

        if (this.submitButton.disabled && this.submitButton.getAttribute('aria-busy') !== 'true') {
          return;
        }

        this._setLoading(true);

        try {
          if (this.clearCart) {
            await fetch(this.cartClearUrl, {
              method: 'POST',
              headers: { Accept: 'application/json' },
              credentials: 'same-origin'
            });
          }

          var response = await fetch(this.cartAddJsUrl, {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json',
              Accept: 'application/json'
            },
            credentials: 'same-origin',
            body: JSON.stringify({
              items: [{ id: Number(variantId), quantity: quantity }]
            })
          });

          var data = await response.json();

          if (!response.ok) {
            throw new Error(data.description || data.message || 'No se pudo agregar el producto.');
          }

          this._goToCheckout();
        } catch (error) {
          this._setLoading(false);
          if (this.textEl) {
            this.textEl.textContent = error.message || 'Error al procesar la compra.';
          }
        }
      }
    }

    customElements.define('wzlt-buy-now-button', WzltBuyNowButton);
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["wzlt-price-badge"] && !Shopify.designMode) return;
  try {
    (function () {
  if (window.customElements.get('wzlt-price-badge')) return;

  class WzltPriceBadge extends HTMLElement {
    connectedCallback() {
      if (this._ready) return;
      this._ready = true;
      this.productId = String(this.getAttribute('data-product-id') || '');
      this.tplPercent = this.getAttribute('data-template-percent') || '-{percent}%';
      this.tplSavings = this.getAttribute('data-template-savings') || '{amount}';
      this.tplUnit = this.getAttribute('data-template-unit') || '{unit_price}/{unit}';
      this.showPercent = this.getAttribute('data-show-percent') !== 'false';
      this.showSavings = this.getAttribute('data-show-savings') === 'true';
      this.showUnit = this.getAttribute('data-show-unit') === 'true';
      this.unitSource = this.getAttribute('data-unit-source') || 'auto';
      this.weightUnit = this.getAttribute('data-weight-unit') || 'auto';
      this.moneyFormat = this.getAttribute('data-money-format') || '';
      this.pageType = this.getAttribute('data-page-type') || '';
      this.designMode = this.getAttribute('data-design-mode') === 'true';
      this.variants = this._parseVariants();
      this._lastExtra = {};
      this._live = this._isLivePriceContext();

      this._onVariantEvent = this._onVariantEvent.bind(this);
      this._onDocChange = this._onDocChange.bind(this);
      this._onLivePointer = this._onLivePointer.bind(this);

      document.addEventListener('variant:change', this._onVariantEvent);
      document.addEventListener('variant:changed', this._onVariantEvent);
      document.addEventListener('variant:update', this._onVariantEvent);
      document.addEventListener('variant:selected', this._onVariantEvent);
      document.addEventListener('product:select', this._onVariantEvent);
      document.addEventListener('shopify:product:select', this._onVariantEvent);
      document.addEventListener('change', this._onDocChange, true);

      this._bindPriceObserver();
      this._bindLiveListeners();
      this._syncFromPage();
    }

    disconnectedCallback() {
      document.removeEventListener('variant:change', this._onVariantEvent);
      document.removeEventListener('variant:changed', this._onVariantEvent);
      document.removeEventListener('variant:update', this._onVariantEvent);
      document.removeEventListener('variant:selected', this._onVariantEvent);
      document.removeEventListener('product:select', this._onVariantEvent);
      document.removeEventListener('shopify:product:select', this._onVariantEvent);
      document.removeEventListener('change', this._onDocChange, true);
      this._unbindLiveListeners();
      if (this._priceObserver) {
        this._priceObserver.disconnect();
        this._priceObserver = null;
      }
      if (this._liveTimer) {
        clearTimeout(this._liveTimer);
        this._liveTimer = null;
      }
    }

    _parseVariants() {
      var map = {};
      var el = this.querySelector('[data-wzlt-price-variants]');
      if (!el) return map;
      try {
        var list = JSON.parse(el.textContent || '[]');
        if (!Array.isArray(list)) return map;
        for (var i = 0; i < list.length; i++) {
          var item = list[i];
          if (!item || item.id == null) continue;
          map[String(item.id)] = item;
        }
      } catch (e) {}
      return map;
    }

    _isLivePriceContext() {
      if (this.pageType !== 'product') return false;
      if (this.closest('product-card')) return false;
      return !!(
        this.closest('.product-details') ||
        this.closest('[id^="ProductInformation"]')
      );
    }

    _liveRoot() {
      return (
        this.closest('.product-details') ||
        this.closest('[id^="ProductInformation"]') ||
        null
      );
    }

    _scope() {
      if (this._live) {
        return this._liveRoot() || document;
      }
      return (
        this.closest('product-card') ||
        this.closest('product-info') ||
        this.closest('.product-information') ||
        this.closest('[data-product-id]') ||
        this.closest('.shopify-section') ||
        document
      );
    }

    _inSameProductScope(node) {
      if (!node || !node.closest) return false;
      var scope = this._scope();
      if (scope === document) return true;
      return scope.contains(node);
    }

    _normalizeId(value) {
      if (value == null || value === '') return '';
      var match = String(value).match(/(\d+)\s*$/);
      return match ? match[1] : String(value);
    }

    _readVariantId() {
      var scope = this._scope();
      var input =
        scope.querySelector('form[action*="/cart/add"] [name="id"]') ||
        scope.querySelector('product-form-component [name="id"]') ||
        scope.querySelector('[name="id"]');
      if (input && input.value) return this._normalizeId(input.value);

      var checked = scope.querySelector('input[data-variant-id]:checked');
      if (checked) return this._normalizeId(checked.getAttribute('data-variant-id'));

      return '';
    }

    _pumperWidget(scope) {
      return (
        (scope && scope.querySelector('#svelte-bundle-widget')) ||
        (scope && scope.querySelector('#pumper_bundle_svelte')) ||
        null
      );
    }

    _pumperSelectedRoot(widget) {
      if (!widget) return null;
      var checked =
        widget.querySelector('input[type="radio"]:checked') ||
        widget.querySelector('input[type="checkbox"]:checked');
      if (checked) {
        return (
          checked.closest('.pumper_template_9_block_wrapper') ||
          checked.closest('.pmpr-tier-shell__card') ||
          checked.closest('.pumper_block__cb') ||
          checked.closest('[class*="tier"]') ||
          checked.parentElement
        );
      }
      return (
        widget.querySelector('[aria-checked="true"]') ||
        widget.querySelector('.pmpr-tier-shell__card.is-selected') ||
        widget.querySelector('.pumper_template_9_block_wrapper.selected') ||
        widget.querySelector('.pumper_template_9_block_wrapper.is-active')
      );
    }

    _isCompareNode(el) {
      if (!el || !el.closest) return false;
      if (el.closest('s, del, compare-at-price, .compare-at-price, .price--compare')) return true;
      if (el.closest('.pmpr-tier-price__compare, .tier-price__compare, .pumper_template_9_prevprice')) return true;
      if (el.id && String(el.id).indexOf('pumper_originalAmount_') === 0) return true;
      return false;
    }

    _centsFromNode(el) {
      if (!el) return null;
      var ds = el.dataset || {};
      var attr =
        ds.productPrice ||
        ds.price ||
        ds.compareAtPrice ||
        ds.comparePrice ||
        el.getAttribute('data-product-price') ||
        el.getAttribute('data-price') ||
        el.getAttribute('data-compare-at-price') ||
        el.getAttribute('data-compare-price');
      if (attr != null && attr !== '') {
        var n = Number(attr);
        if (isFinite(n) && n >= 0) {
          if (n > 0 && n < 100000 && String(attr).indexOf('.') !== -1) {
            return Math.round(n * 100);
          }
          return Math.round(n);
        }
      }
      return this._parseMoneyToCents(el.textContent);
    }

    _parseMoneyToCents(text) {
      if (text == null) return null;
      var raw = String(text).replace(/\u00a0/g, ' ').trim();
      if (!raw) return null;
      var format = this.moneyFormat || '';
      var commaDecimal = /\{\{\s*amount_with_comma_separator/.test(format);
      var cleaned = raw.replace(/[^\d,.]/g, '');
      if (!cleaned) return null;
      var hasComma = cleaned.indexOf(',') !== -1;
      var hasDot = cleaned.indexOf('.') !== -1;
      if (hasComma && hasDot) {
        if (cleaned.lastIndexOf(',') > cleaned.lastIndexOf('.')) {
          cleaned = cleaned.replace(/\./g, '').replace(',', '.');
        } else {
          cleaned = cleaned.replace(/,/g, '');
        }
      } else if (hasComma) {
        if (commaDecimal || /,\d{1,2}$/.test(cleaned)) {
          cleaned = cleaned.replace(',', '.');
        } else {
          cleaned = cleaned.replace(/,/g, '');
        }
      }
      var n = parseFloat(cleaned);
      if (!isFinite(n) || n < 0) return null;
      return Math.round(n * 100);
    }

    _firstMoney(root, selectors) {
      if (!root) return null;
      for (var i = 0; i < selectors.length; i++) {
        var nodes = root.querySelectorAll(selectors[i]);
        for (var j = 0; j < nodes.length; j++) {
          var cents = this._centsFromNode(nodes[j]);
          if (cents != null && cents >= 0) return cents;
        }
      }
      return null;
    }

    _readPumperPrices(scope) {
      var widget = this._pumperWidget(scope);
      if (!widget) return null;
      var selected = this._pumperSelectedRoot(widget);
      if (!selected) return null;
      var price = this._firstMoney(selected, [
        '.pmpr-tier-price__total .pmpr-money-text',
        '.tier-price__main .pmpr-money-text',
        '[id^="pumper_totalAmount_"] .pmpr-money-text',
        '[id^="pumper_totalAmount_"]',
        '.tier-price__main',
        '.pumper_totalAmount_wrapper .pmpr-money-text'
      ]);
      var compare = this._firstMoney(selected, [
        '.pmpr-tier-price__compare .pmpr-money-text',
        '.tier-price__compare .pmpr-money-text',
        '[id^="pumper_originalAmount_"] .pmpr-money-text',
        '[id^="pumper_originalAmount_"]',
        '.pumper_template_9_prevprice .pmpr-money-text',
        '.pumper_template_9_prevprice'
      ]);
      if (price == null) return null;
      return { price: price, compare: compare || 0 };
    }

    _readThemePrices(scope) {
      var widget = this._pumperWidget(scope);
      var price = null;
      var compare = null;
      var nodes = scope.querySelectorAll(
        '.pmpr-money-text, compare-at-price, .compare-at-price, sale-price, .price-item--sale, .price-item--regular, [ref="priceContainer"] .price, product-price .price'
      );
      for (var i = 0; i < nodes.length; i++) {
        var el = nodes[i];
        if (this.contains(el)) continue;
        if (widget && widget.contains(el)) continue;
        if (el.querySelector && el.querySelector('.pmpr-money-text, sale-price, .compare-at-price, .price-item--sale, .price-item--regular')) {
          continue;
        }
        var cents = this._centsFromNode(el);
        if (cents == null) continue;
        if (this._isCompareNode(el)) {
          if (compare == null) compare = cents;
        } else if (price == null) {
          price = cents;
        }
      }
      if (price == null && compare == null) return null;
      return { price: price || 0, compare: compare || 0 };
    }

    _readLiveQty(scope) {
      var qty = 1;
      var input =
        scope.querySelector('form[action*="/cart/add"] [name="quantity"]') ||
        scope.querySelector('[name="quantity"]');
      if (input && Number(input.value) >= 1) qty = Number(input.value);

      var widget = this._pumperWidget(scope);
      var selected = this._pumperSelectedRoot(widget);
      if (selected) {
        var dq =
          selected.getAttribute('data-qty') ||
          selected.getAttribute('data-quantity') ||
          selected.getAttribute('data-units');
        if (!dq) {
          var qtyEl = selected.querySelector('[data-qty], [data-quantity]');
          if (qtyEl) {
            dq = qtyEl.getAttribute('data-qty') || qtyEl.getAttribute('data-quantity');
          }
        }
        if (dq && Number(dq) >= 1) {
          qty = Number(dq);
        } else {
          var label = selected.textContent || '';
          var match = label.match(/x\s*(\d+)/i) || label.match(/\((\d+)\s*unid/i);
          if (match && Number(match[1]) >= 1) qty = Number(match[1]);
        }
      }
      if (!isFinite(qty) || qty < 1) qty = 1;
      return qty;
    }

    _readPricesFromDom() {
      var scope = this._scope();
      if (this._live) {
        var pumper = this._readPumperPrices(scope);
        var theme = this._readThemePrices(scope);
        var price = null;
        var compare = null;
        if (theme && theme.price > 0) price = theme.price;
        if (pumper && pumper.price > 0) price = pumper.price;
        if (theme && theme.compare > 0) compare = theme.compare;
        if (pumper && pumper.compare > 0) compare = pumper.compare;
        if (price == null && compare == null) return null;
        return { price: price || 0, compare: compare || 0 };
      }

      var candidates = scope.querySelectorAll(
        '[data-compare-at-price], [data-compare-price], [data-product-price], product-price, .price, [ref="priceContainer"]'
      );
      var price = null;
      var compare = null;

      for (var i = 0; i < candidates.length; i++) {
        var el = candidates[i];
        if (this.contains(el)) continue;
        var ds = el.dataset || {};
        var p =
          ds.productPrice ||
          ds.price ||
          el.getAttribute('data-product-price') ||
          el.getAttribute('data-price');
        var c =
          ds.compareAtPrice ||
          ds.comparePrice ||
          el.getAttribute('data-compare-at-price') ||
          el.getAttribute('data-compare-price');
        if (p != null && p !== '' && price == null) price = Number(p);
        if (c != null && c !== '' && compare == null) compare = Number(c);
      }

      if ((price == null || isNaN(price)) && (compare == null || isNaN(compare))) {
        return null;
      }
      return {
        price: price || 0,
        compare: compare || 0
      };
    }

    _formatMoney(cents) {
      var amount = (Number(cents) || 0) / 100;
      var formatted = amount.toFixed(2);
      var format = this.moneyFormat;
      if (window.Shopify && typeof Shopify.formatMoney === 'function') {
        try {
          return Shopify.formatMoney(cents, format);
        } catch (e) {}
      }
      if (!format) return formatted;
      return String(format)
        .replace(/\{\{\s*amount_with_comma_separator\s*\}\}/g, formatted.replace('.', ','))
        .replace(
          /\{\{\s*amount_no_decimals_with_comma_separator\s*\}\}/g,
          String(Math.round(amount)).replace(/\B(?=(\d{3})+(?!\d))/g, '.')
        )
        .replace(/\{\{\s*amount_no_decimals\s*\}\}/g, String(Math.round(amount)))
        .replace(/\{\{\s*amount\s*\}\}/g, formatted);
    }

    _formatQty(value) {
      var n = Number(value);
      if (!isFinite(n) || n <= 0) return '';
      if (Math.abs(n - Math.round(n)) < 0.001) return String(Math.round(n));
      return String(Math.round(n * 100) / 100);
    }

    _fill(template, map) {
      var out = String(template || '');
      var keys = Object.keys(map);
      for (var i = 0; i < keys.length; i++) {
        var key = keys[i];
        out = out.split('{' + key + '}').join(map[key] == null ? '' : String(map[key]));
      }
      return out;
    }

    _convertWeight(grams, unit) {
      var g = Number(grams) || 0;
      if (unit === 'kg') return { value: g / 1000, unit: 'kg' };
      if (unit === 'oz') return { value: g / 28.349523125, unit: 'oz' };
      if (unit === 'lb') return { value: g / 453.59237, unit: 'lb' };
      return { value: g, unit: 'g' };
    }

    _shopifyUnitSuffix(refValue, refUnit) {
      var unit = refUnit == null ? '' : String(refUnit);
      if (!unit) return '';
      var value = Number(refValue);
      if (!isFinite(value) || value === 1) return unit;
      return String(value) + unit;
    }

    _resolveUnit(variant, price) {
      if (!this.showUnit) return null;
      var source = this.unitSource;
      var packQty = Math.max(1, Number(variant && variant.liveQty) || 1);
      var mfQty = variant && Number(variant.mf_qty);
      var mfUnit = variant && variant.mf_unit ? String(variant.mf_unit) : '';
      var mfLabel = variant && variant.mf_label ? String(variant.mf_label) : '';

      if (source === 'auto' || source === 'metafield') {
        if (mfQty > 0) {
          var abbr = mfUnit || mfLabel;
          var totalMf = mfQty * packQty;
          return {
            qty: totalMf,
            unit: abbr,
            label: mfLabel || abbr,
            unitPrice: price / totalMf
          };
        }
        if (source === 'metafield') return null;
      }

      if (source === 'auto' || source === 'shopify') {
        var nativePrice = variant && Number(variant.unit_price);
        var refUnit = variant && variant.ref_unit;
        if (nativePrice > 0 && refUnit) {
          var suffix = this._shopifyUnitSuffix(variant.ref_value, refUnit);
          var baseQty = Number(variant.qty_value) || 0;
          var variantPrice = Number(variant.price) || 0;
          var unitPrice = nativePrice;
          if (packQty > 1 && baseQty > 0) {
            unitPrice = price / (baseQty * packQty);
          } else if (variantPrice > 0 && price > 0 && price !== variantPrice) {
            unitPrice = nativePrice * (price / variantPrice);
          }
          return {
            qty: baseQty > 0 ? baseQty * packQty : packQty,
            unit: suffix,
            label: mfLabel || suffix,
            unitPrice: unitPrice
          };
        }
        if (source === 'shopify') return null;
      }

      if (source === 'weight' && variant) {
        var grams = Number(variant.weight) || 0;
        var converted;
        if (this.weightUnit === 'auto') {
          converted = {
            value: Number(variant.weight_in_unit) || 0,
            unit: variant.weight_unit || 'g'
          };
        } else {
          converted = this._convertWeight(grams, this.weightUnit);
        }
        if (converted.value > 0) {
          var totalW = converted.value * packQty;
          return {
            qty: totalW,
            unit: converted.unit,
            label: mfLabel || converted.unit,
            unitPrice: price / totalW
          };
        }
      }

      return null;
    }

    _setPill(el, text, visible) {
      if (!el) return false;
      if (visible && text) {
        el.textContent = text;
        el.hidden = false;
        return true;
      }
      if (this.designMode) {
        el.hidden = false;
        return true;
      }
      el.textContent = '';
      el.hidden = true;
      return false;
    }

    _apply(price, compare, extra) {
      extra = extra || this._lastExtra || {};
      this._lastExtra = extra;
      this._updating = true;

      var pct = 0;
      var saveAmount = 0;
      if (compare > price && compare > 0) {
        saveAmount = compare - price;
        pct = Math.round((saveAmount * 100) / compare);
      }

      var unitInfo = this._resolveUnit(extra, price);
      var tokens = {
        percent: pct,
        amount: saveAmount >= 1 ? this._formatMoney(saveAmount) : '',
        unit_price: unitInfo ? this._formatMoney(Math.round(unitInfo.unitPrice)) : '',
        unit: unitInfo ? unitInfo.unit : '',
        qty: unitInfo ? this._formatQty(unitInfo.qty) : '',
        label: unitInfo ? unitInfo.label : ''
      };

      var anyVisible = false;
      var percentEl = this.querySelector('[data-wzlt-pill="percent"]');
      var savingsEl = this.querySelector('[data-wzlt-pill="savings"]');
      var unitEl = this.querySelector('[data-wzlt-pill="unit"]');

      if (this.showPercent && percentEl) {
        if (this._setPill(percentEl, this._fill(this.tplPercent, tokens), pct >= 1)) {
          anyVisible = true;
        }
      }
      if (this.showSavings && savingsEl) {
        if (this._setPill(savingsEl, this._fill(this.tplSavings, tokens), saveAmount >= 1)) {
          anyVisible = true;
        }
      }
      if (this.showUnit && unitEl) {
        if (this._setPill(unitEl, this._fill(this.tplUnit, tokens), !!(unitInfo && unitInfo.unitPrice > 0))) {
          anyVisible = true;
        }
      }

      if (anyVisible || (this.designMode && (this.showPercent || this.showSavings || this.showUnit))) {
        this.hidden = false;
      } else {
        this.hidden = true;
      }

      this._updating = false;
    }

    _variantExtra(variantId) {
      var id = this._normalizeId(variantId);
      var base = (id && this.variants[id]) || this._lastExtra || {};
      var extra = {};
      var keys = Object.keys(base);
      for (var i = 0; i < keys.length; i++) extra[keys[i]] = base[keys[i]];
      if (this._live) extra.liveQty = this._readLiveQty(this._scope());
      return extra;
    }

    _syncFromVariantId(variantId) {
      var id = this._normalizeId(variantId);
      if (!id || !this.variants[id]) return false;
      var v = this.variants[id];
      this._apply(Number(v.price) || 0, Number(v.compare) || 0, this._variantExtra(id));
      return true;
    }

    _syncFromPage() {
      var id = this._readVariantId();

      if (this._live) {
        var fromDom = this._readPricesFromDom();
        if (fromDom && fromDom.price > 0) {
          var extra = this._variantExtra(id);
          var compare = fromDom.compare > 0 ? fromDom.compare : Number(extra.compare) || 0;
          this._apply(fromDom.price, compare, extra);
          return;
        }
      }

      if (id && this._syncFromVariantId(id)) return;

      var attrPrices = this._readPricesFromDom();
      if (attrPrices) {
        this._apply(attrPrices.price, attrPrices.compare, this._variantExtra(id));
        return;
      }

      if (id && this.variants[id]) {
        this._syncFromVariantId(id);
      }
    }

    _scheduleLiveSync() {
      if (!this._live) {
        this._syncFromPage();
        return;
      }
      var self = this;
      if (this._liveTimer) clearTimeout(this._liveTimer);
      this._liveTimer = setTimeout(function () {
        self._liveTimer = null;
        self._syncFromPage();
      }, 80);
    }

    _onVariantEvent(event) {
      if (this._live) {
        this._scheduleLiveSync();
        return;
      }

      var detail = (event && event.detail) || {};
      var variant = detail.variant || detail.currentVariant || detail;
      var id =
        (variant && (variant.id || variant.variantId)) ||
        detail.variantId ||
        detail.id ||
        '';
      if (id && this._syncFromVariantId(id)) return;

      var price = variant && (variant.price != null ? variant.price : null);
      var compare =
        variant &&
        (variant.compare_at_price != null
          ? variant.compare_at_price
          : variant.compareAtPrice != null
            ? variant.compareAtPrice
            : null);
      if (price != null && compare != null) {
        this._apply(Number(price) || 0, Number(compare) || 0, this._variantExtra(id));
        return;
      }

      this._syncFromPage();
    }

    _onDocChange(event) {
      var target = event && event.target;
      if (!target || !this._inSameProductScope(target)) return;
      if (this._live) {
        this._scheduleLiveSync();
        return;
      }
      if (
        target.name === 'id' ||
        (target.getAttribute && target.getAttribute('data-variant-id')) ||
        (target.closest && target.closest('variant-picker'))
      ) {
        this._syncFromPage();
      }
    }

    _onLivePointer(event) {
      var target = event && event.target;
      if (!target || !this._inSameProductScope(target)) return;
      this._scheduleLiveSync();
    }

    _bindLiveListeners() {
      if (!this._live) return;
      var root = this._liveRoot();
      if (!root) return;
      root.addEventListener('click', this._onLivePointer, true);
      root.addEventListener('input', this._onLivePointer, true);
    }

    _unbindLiveListeners() {
      var root = this._liveRoot();
      if (!root) return;
      root.removeEventListener('click', this._onLivePointer, true);
      root.removeEventListener('input', this._onLivePointer, true);
    }

    _bindPriceObserver() {
      if (typeof MutationObserver !== 'function') return;
      var scope = this._scope();
      if (!scope || scope === document) return;
      var self = this;
      this._priceObserver = new MutationObserver(function (mutations) {
        if (self._updating) return;
        var external = false;
        for (var i = 0; i < mutations.length; i++) {
          var target = mutations[i].target;
          if (target && !self.contains(target)) {
            external = true;
            break;
          }
        }
        if (!external) return;
        if (self._live) self._scheduleLiveSync();
        else self._syncFromPage();
      });
      var config = {
        subtree: true,
        childList: true,
        attributes: true,
        attributeFilter: [
          'data-price',
          'data-product-price',
          'data-compare-at-price',
          'data-compare-price',
          'content',
          'value',
          'class',
          'aria-checked',
          'checked'
        ]
      };
      if (this._live) config.characterData = true;
      this._priceObserver.observe(scope, config);
    }
  }

  window.customElements.define('wzlt-price-badge', WzltPriceBadge);
})();
  } catch(e) { console.error(e); }
})();

})();
